<template>
  <onboarding-container>
    <h2 class="onboarding--heading">Welcome To Forefront</h2>

    <div class="video-container">
      <div class="video">
        <iframe
          class="iframe"
          src="https://www.youtube.com/embed/KGz4sevq0Rg"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>

    <div class="onboarding--content">
      <p class="onboarding--text">Forefront is a CRM that can be as simple or as powerful as you want depending on how you set it up. If you are just starting out and just need to start tracking leads then we recommend just getting the defaults and jumping right in.</p>
      <p class="onboarding--text">If you've done some deals and a way of doing things then we recommend going thru the Setup Wizard below. You'll set up statuses, marketing campaigns, integrations, and more.</p>
      <p class="onboarding--text">And if you just want Forefront setup the way you want with minimal hassle we offer a white glove service for $997. We'll jump on a call, learn about your business needs, and then get your account set up and fully integrated.</p>
    </div>

    <div class="my-200">
      <p class="onboarding--subheading">How would you to proceed?</p>

      <div class="flex flex-between">
        <button-outlined
          @click="defaultSetUp"
          size=""
        >Default Setup
        </button-outlined>

        <button-outlined
          @click="setupWizard"
          size=""
        >Setup Wizard
        </button-outlined>

        <button-outlined
          @click="whiteGlove"
          size=""
        >White Glove Service
        </button-outlined>
      </div>
    </div>
  </onboarding-container>
</template>

<script>
import {defineComponent} from 'vue'
import OnboardingContainer from "./component/OnboardingContainer.vue";

export default defineComponent({
  name: "OnboardingWelcomePage",
  metaInfo: {
    title: "Welcome to Forefront"
  },
  components: {OnboardingContainer},
  beforeRouteEnter(to, from, next) {

    next(vm => {
      vm.$store.commit('onboarding/updateOnboarding', vm.$store.getters.account.onboarding);

      if(vm.$store.state.onboarding.hasWhiteGloveService) {
        next({name: 'onboarding-white-glove'})
      } else if(vm.$store.state.onboarding.onboarding.is_provisioned) {
        next({name: 'onboarding-provisioning'})
      } else {
        next()
      }
    })
  },
  methods: {
    defaultSetUp() {
      this.$router.push({name: 'onboarding-provisioning'})
    },
    whiteGlove() {
      this.$router.push({name: 'onboarding-white-glove'})
    },
    setupWizard() {
      this.$router.push({name: 'onboarding-wizard-1'})
    },
  },
})
</script>

<style scoped lang="scss">
.onboarding {
  &--heading {
    margin: 1rem 0;
    font-size: 2.5rem;
    font-weight: bold;
    text-align: center;
  }

  &--content {
    margin-top: 2rem;
  }

  &--text {
    margin-bottom: 10px;
    line-height: 1.3;
  }

  &--subheading {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    font-weight: bold;
  }
}

.video-container {
  position: relative;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;

  .video {
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
  }

  .iframe {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
  }
}
</style>
